import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";
import { forwardRef } from "react";
import { Box } from "./Box";

export type ButtonProps = MuiButtonProps & {
  textTransform?: "none" | "capitalize" | "uppercase" | "lowercase";
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ sx, textTransform, children, ...rest }, ref) => {
  return (
    <MuiButton ref={ref} sx={{ minWidth: "80px", textTransform: textTransform, ...sx }} {...rest}>
      {children}
    </MuiButton>
  );
});
